import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
const LEVEL_CLASS = {
    none: false,
    subtle: 'sec-highlight--subtle',
    moderate: 'sec-highlight--moderate',
    strong: 'sec-highlight--strong',
    critical: 'sec-highlight--critical',
};
/**
 * Karte mit Akzentrand nach Dringlichkeit (`.sec-card` + `.sec-highlight--*`).
 * Domänenfrei: Aufrufer bestimmt `level` und `indicator`. Mit `onClick` wird die
 * Karte interaktiv (role=button + Tastaturbedienung).
 */
export const HighlightedCard = forwardRef(function HighlightedCard({ level = 'none', indicator, className, children, onClick, ...rest }, ref) {
    const interactive = typeof onClick === 'function';
    const handleKeyDown = interactive
        ? (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick?.(e);
            }
        }
        : undefined;
    return (_jsxs("div", { ref: ref, className: cn('sec-card', 'sec-highlight', LEVEL_CLASS[level], className), onClick: onClick, role: interactive ? 'button' : undefined, tabIndex: interactive ? 0 : undefined, onKeyDown: handleKeyDown, ...rest, children: [indicator ? (_jsx("div", { className: "sec-highlight__indicator", role: "img", "aria-label": "Dringlichkeit", children: indicator })) : null, children] }));
});
